import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ProgressData } from 'src/app/modules/shared/dtos/progress-data';
import { ResponseModel } from 'src/app/modules/shared/models/reponse.model';
import { ProgressIndicatingService } from 'src/app/modules/shared/services/progress-indicating.service';
import { UpdatePasswordService } from '../../services/update-password-service';

@Component({
    selector: 'app-update-password',
    templateUrl: './update-password.component.html',
    styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {
    public updatePasswordForm: FormGroup;
    public hasLowerCasePassed : boolean = false;
    public hasUpperCasePassed : boolean = false;
    public hasNumberPassed : boolean = false;
    public hasSpecialCharactersPassed : boolean = false;
    public stringLengthPassed : boolean = false;
    public showMessage : string = '';
    public passwordsMatch : boolean = false;
    private unsubscribe$ = new Subject<void>();
    private progress$ = new Subject<ProgressData>();

    public constructor(private updatePasswordService : UpdatePasswordService, private config: DynamicDialogConfig,
        private messageService: MessageService, private progressIndicatingService: ProgressIndicatingService) {}

    public ngOnInit(): void {
        this.updatePasswordForm = new FormGroup({
            newPassword: new FormControl(null, [Validators.required]),
            confirmPassword: new FormControl(null, Validators.required)
        });
        this.updatePasswordForm.get('newPassword')?.valueChanges.subscribe((data: string) => {
            this.hasLowerCasePassed = this.hasLowerCase(data);
            this.hasUpperCasePassed = this.hasUpperCase(data);
            this.hasNumberPassed = this.hasNumber(data);
            this.hasSpecialCharactersPassed = this.hasSpecialCharacter(data);
            this.stringLengthPassed = this.stringLength(data);
            if (this.updatePasswordForm.value.confirmPassword !== null) {
                this.showMessage = this.matchPasswords(data, this.updatePasswordForm.value.confirmPassword);
            }
        });
        this.updatePasswordForm.get('confirmPassword')?.valueChanges.subscribe((data : string) => {
            this.showMessage = this.matchPasswords(this.updatePasswordForm.value.newPassword, data);
        });
    }

    public hasLowerCase(str : string) : boolean {
        return (/[a-z]/.test(str));
    }

    public hasUpperCase(str : string) : boolean {
        return (/[A-Z]/.test(str));
    }

    public hasNumber(str : string) : boolean {
        return (/[0-9]/.test(str));
    }

    public hasSpecialCharacter(str : string) : boolean {
        return (/[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/.test(str));
    }

    public stringLength(str : string) : boolean {
        return str.length >= 10;
    }

    public update() : boolean {
        if (this.hasLowerCasePassed && this.hasUpperCasePassed && this.hasNumberPassed &&
        this.stringLengthPassed && this.hasSpecialCharactersPassed && this.showMessage === 'Passwords match') {
            return false;
        } else {
            return true;
        }
    }

    public matchPasswords(newPswd : string, confirmNewPswd: string) : string {
        if (newPswd !== confirmNewPswd) {
            this.passwordsMatch = true;
            return 'Passwords donot match';
        } else {
            this.passwordsMatch = false;
            return 'Passwords match';
        }
    }

    public resetPassword() : void {
        this.progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Resetting Password',
                details: 'Please wait...',
                done: false
            }
        });
        // const password = btoa(this.updatePasswordForm.value.newPassword);
        const newPassword = btoa(this.updatePasswordForm.value.confirmPassword);
        const partnerId = this.config.data.partnerId;
        const isreset = true;
        this.updatePasswordService.resetPassword(newPassword, partnerId, isreset).pipe(
            map(response => new ResponseModel(response)),
            takeUntil(this.unsubscribe$)).subscribe(
            () => {
                this.sendProgressDoneSignal();
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Password has been Successfully Reset ' });
            },
            response => {
                this.sendProgressDoneSignal();
                this.messageService.add({ severity: 'error', summary: 'err', detail: new ResponseModel(response.error).message });
            }
        );
    }

    private sendProgressDoneSignal(): void {
        this.progress$.next({
            header: '',
            done: true
        });
    }
}
